import { useEffect, useRef } from "react";
import tocbot from "tocbot";
import "./ShortCut.scss";

/**
 * 목차 수집 대상 헤딩
 * - Level1: h2.manual-content-title (본문) + description 내 h1
 * - Level2: h3.manual-subcontent-title (그룹) + description 내 h2
 */
const TOC_HEADING_SELECTOR = [
  "h2.manual-content-title",
  "h3.manual-subcontent-title",
  ".manual-content-description h1",
  ".manual-content-description h2",
  ".manual-subcontent-description h1",
  ".manual-subcontent-description h2",
].join(", ");

const HEADER_OFFSET = 80;

var browse = navigator.userAgent.toLowerCase();

/**
 * 우측 목차(TOC)
 * props: manualRef(본문), data(재수집 트리거), hash(딥링크)
 */
export default function ShortCut(props) {
  const tocRef = useRef();

  useEffect(() => {
    const contentEl = props.manualRef?.current;
    const tocEl = tocRef.current;
    if (!contentEl || !tocEl) return;

    contentEl
      .querySelectorAll(TOC_HEADING_SELECTOR)
      .forEach((heading, index) => {
        if (heading.id) {
          return;
        }
        heading.id = `heading-${index}`;
      });

    tocbot.init({
      tocElement: tocEl,
      contentElement: contentEl,
      headingSelector: TOC_HEADING_SELECTOR,
      hasInnerContainers: false,
      collapseDepth: 3,
      orderedList: false,
      scrollHandlerType: "throttle",
      headingsOffset: HEADER_OFFSET,
      scrollSmooth: false,
      scrollSmoothOffset: -HEADER_OFFSET,
      onClick: function (event) {
        event.preventDefault();
        const targetId = event.target.getAttribute("href")?.substring(1);
        const targetElement = document.getElementById(targetId);

        if (!targetElement) return;

        if (browse.indexOf("trident") !== -1 || browse.indexOf("msie") !== -1) {
          targetElement.scrollIntoView();
          window.scrollTo(0, targetElement.offsetTop);
        } else {
          window.scrollTo({ top: targetElement.offsetTop, behavior: "smooth" });
        }
      },
    });

    if (props.hash) {
      const target =
        document.getElementById(props.hash) ||
        Array.from(contentEl.querySelectorAll(TOC_HEADING_SELECTOR)).find(
          (el) => el.textContent?.trim() === props.hash,
        );
      if (target) {
        window.scrollTo({
          top: target.offsetTop - HEADER_OFFSET,
          behavior: "smooth",
        });
      }
    }

    return () => tocbot.destroy();
  }, [props.manualRef, props.data, props.hash]);

  return (
    <div className="shortcut">
      <div className="component-shortcutdiv" ref={tocRef} />
    </div>
  );
}
